<div class="container-fluid">
    <app-page-title title="API Configuration"></app-page-title>
    <form [formGroup]="apiConfigForm" (ngSubmit)="upsert();" (keydown.enter)="useEnterKey ? $event.preventDefault() : upsert()">
        <div class="row">
            <div class="col-sm-8 d-flex flex-grow-1 flex-column">
                <div class="card flex-grow-1">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-3">
                                <div class="mb-2">
                                    <label class="form-label" for="Vendor">Vendor<span
                                            class="mandatory">*</span></label>
                                    <input type="text" class="form-control form-control-sm" id="Vendor"
                                        formControlName="txtVendor" readonly >
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="mb-2">
                                    <label class="form-label" for="accCode">Account Code<span
                                            class="mandatory">*</span></label>
                                    <ng-select id="accCode" placeholder="Select" formControlName="ddlAccCode"
                                        [items]="accCodeList" bindLabel="accountcode" [bindValue]="'accountcode'"
                                        [appendTo]="'body'" [openOnEnter]="false"
                                        [ngClass]="{'is-invalid': (isFormSubmitted || apiConfigForm.get('ddlAccCode').touched) && apiConfigForm.get('ddlAccCode').errors}" >
                                    </ng-select>
                                    <div *ngIf="(isFormSubmitted || apiConfigForm.get('ddlAccCode').touched) && apiConfigForm.get('ddlAccCode').errors"
                                        class="invalid-feedback">
                                        <span *ngIf="apiConfigForm.get('ddlAccCode').errors.required">Account Code is required</span>
                                        <span *ngIf="apiConfigForm.get('ddlAccCode').errors.maxlength">Max of 30 characters allowed.</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="mb-2">
                                    <label for="service" class="form-label">Service<span
                                            class="mandatory">*</span></label>
                                    <ng-select id="service" formControlName="ddlService" placeholder="Select"
                                        [appendTo]="'body'" [openOnEnter]="false" [items]="serviceList" bindLabel="servicename"
                                        [bindValue]="'servicename'"
                                        [ngClass]="{'is-invalid': (isFormSubmitted || apiConfigForm.get('ddlService')?.touched) && apiConfigForm.get('ddlService').errors}" ></ng-select>
                                    <div *ngIf="(isFormSubmitted || apiConfigForm.get('ddlService')?.touched) && apiConfigForm.get('ddlService').errors"
                                        class="invalid-feedback">
                                        <span *ngIf="apiConfigForm.get('ddlService').errors.required">Service is Required</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-3">
                                <div class="mb-2">
                                    <label for="product" class="form-label">Product</label>
                                    <ng-select id="product" [items]="productList" bindLabel="name" [bindValue]="'code'"
                                        [appendTo]="'body'" [openOnEnter]="false" formControlName="ddlProduct" placeholder="Select"
                                        class="ng-select ng-select-single ng-select-searchable ng-select-clearable ng-select-bottom"
                                        [ngClass]="{'is-invalid': (isFormSubmitted || apiConfigForm.get('ddlProduct')?.touched) && apiConfigForm.get('ddlProduct').errors}" >
                                        <ng-template ng-option-tmp let-item="item" let-disabled="item.disabled">
                                            <span>{{ item.name }}</span>
                                        </ng-template>
                                    </ng-select>
                                    <div *ngIf="(isFormSubmitted || apiConfigForm.get('ddlProduct')?.touched) && apiConfigForm.get('ddlProduct').errors"
                                        class="invalid-feedback">
                                        <span *ngIf="apiConfigForm.get('ddlProduct').errors.required">Product is Required</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6"> <label for="minweight" class="form-label">Weight</label>
                                <div class="input-group mb-2">
                                    <span class="input-group-text group-label-sm">Min</span>
                                    <input type="number" formControlName="txtMinWeight"
                                        class="form-control form-control-sm ng-untouched ng-pristine ng-valid"
                                        ng-reflect-name="txtMinWeight" >
                                    <span class="input-group-text group-label-sm">Max</span>
                                    <input type="number" formControlName="txtMaxWeight"
                                        class="form-control form-control-sm ng-untouched ng-pristine ng-valid"
                                        ng-reflect-name="txtMaxWeight" >
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-sm-4 d-flex flex-grow-1 flex-column">
                <div class="card flex-grow-1">
                    <div class="card-header bg-transparent border-bottom text-uppercase">
                        FORWARDING DETAILS
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="">
                                    <label for="apiservice" class="form-label">API Service </label>
                                    <input type="text" class="form-control form-control-sm" id="apiservice"
                                        formControlName="txtApiService" maxlength="50" >
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="">
                                    <label for="apipackaging" class="form-label">API Packaging </label>
                                    <input type="text" class="form-control form-control-sm" id="apipackaging"
                                        formControlName="txtApiPackaging" maxlength="50" >
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-header bg-transparent border-bottom text-uppercase">Origin</div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-2">
                                <div class="mb-2">
                                    <label for="country" class="form-label">Country</label>
                                    <ng-select id="country" formControlName="ddlOriginCountry" placeholder="Select"
                                        [items]="countryList" bindLabel="name" [bindValue]="'isocode'"
                                        [appendTo]="'body'" [openOnEnter]="false" (change)="onOriginCountryChange()"
                                        [ngClass]="{'is-invalid': (isFormSubmitted || apiConfigForm.get('ddlOriginCountry')?.touched) && apiConfigForm.get('ddlOriginCountry').errors}" ></ng-select>
                                    <div *ngIf="(isFormSubmitted || apiConfigForm.get('ddlOriginCountry')?.touched) && apiConfigForm.get('ddlOriginCountry').errors"
                                        class="invalid-feedback">
                                        <span *ngIf="apiConfigForm.get('ddlOriginCountry').errors.required">Origin Country is Required</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-2">
                                <div class="mb-2">
                                    <label for="state" class="form-label">State</label>
                                    <ng-select id="state" formControlName="ddlOriginState" placeholder="Select"
                                        [items]="originStateList" bindLabel="name" [bindValue]="'isocode'"
                                        [appendTo]="'body'" [openOnEnter]="false" (change)="onOriginStateChange()" />
                                </div>
                            </div>
                            <div class="col-md-2">
                                <div class="mb-2">
                                    <label for="city" class="form-label">City</label>
                                    <ng-select id="city" formControlName="ddlOriginCity" placeholder="Select"
                                        [appendTo]="'body'" [openOnEnter]="false" [items]="originCityList" bindLabel="name"
                                        [bindValue]="'isocode'" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-header bg-transparent border-bottom text-uppercase">Destination</div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-2">
                                <div class="mb-2">
                                    <label for="country" class="form-label">Country</label>
                                    <ng-select id="country" formControlName="ddlDestinationCountry" placeholder="Select"
                                        [items]="countryList" bindLabel="name" [bindValue]="'isocode'"
                                        [appendTo]="'body'" [openOnEnter]="false" (change)="onDestinationCountryChange()"
                                        [ngClass]="{'is-invalid': (isFormSubmitted || apiConfigForm.get('ddlDestinationCountry')?.touched) && apiConfigForm.get('ddlDestinationCountry').errors}" ></ng-select>
                                    <div *ngIf="(isFormSubmitted || apiConfigForm.get('ddlDestinationCountry')?.touched) && apiConfigForm.get('ddlDestinationCountry').errors"
                                        class="invalid-feedback">
                                        <span
                                            *ngIf="apiConfigForm.get('ddlDestinationCountry').errors.required">Destination Country is Required</span>
                                    </div>

                                </div>
                            </div>
                            <div class="col-md-2">
                                <div class="mb-2">
                                    <label for="state" class="form-label">State</label>
                                    <ng-select id="state" formControlName="ddlDestinationState" placeholder="Select"
                                        [items]="destinationStateList" bindLabel="name" [bindValue]="'isocode'"
                                        [appendTo]="'body'" [openOnEnter]="false" (change)="onDestinationStateChange()" />
                                </div>
                            </div>
                            <div class="col-md-2">
                                <div class="mb-2">
                                    <label for="city" class="form-label">City</label>
                                    <ng-select id="city" formControlName="ddlDestinationCity" placeholder="Select"
                                        [appendTo]="'body'" [openOnEnter]="false" [items]="destinationCityList" bindLabel="name"
                                        [bindValue]="'isocode'" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <div class="button-items">
                    <button type="submit" class="btn btn-primary btn-md w-sm" >  {{editMode ? 'Update' : 'Save'}}</button>
                    <button type="button" class="btn btn-primary btn-md w-sm" (click)="resetForm()" >Reset</button>
                    <a routerLink="/setup/vendors"><button type="button"
                            class="btn btn-secondary btn-md w-sm">Cancel</button></a>
                </div>
            </div>
        </div>
        <div class="row mt-2">
            <div class="card">
                <div class="card-header bg-transparent border-bottom text-uppercase">Configuration</div>
                <div class="card-body">
                    <div class="col-md-12 grid-container">
                        <ag-grid-angular #agGrid style="width: 100%; height: 100%" id="myGrid" class="ag-theme-balham"
                            [rowData]="rowData" [columnDefs]="columnDefs" [animateRows]="true" [context]="context"
                            [defaultColDef]="defaultColDef" [gridOptions]="gridOptions" [suppressMenuHide]="true"
                            [pagination]="true" (gridReady)="onGridReady($event)">
                        </ag-grid-angular>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>